<template>
  <w-icon-wrapper
    :height='18'
    :width='18'
    icon-name='work-checkbox-select-icon'
    view-box='0 0 18 18'
  >
    <g
      id="Checkbox_Selected"
      transform="translate(-1147 -461)"
    >
      <rect
        id="Rechteck_4031"
        data-name="Rechteck 4031"
        width="18"
        height="18"
        rx="2"
        transform="translate(1147 461)"
        fill="currentColor"
      />
      <path
        id="Pfad_55780"
        data-name="Pfad 55780"
        d="M4.891,11.622a.847.847,0,0,0,1.227,0l6.133-6.133a.867.867,0,1,0-1.227-1.227L5.5,9.783,3.489,7.767a.847.847,0,0,0-1.227,0,.847.847,0,0,0,0,1.227Z"
        transform="translate(1148.742 462.057)"
        fill="#fff"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheckboxSelect' };
</script>
